import React, { useContext } from 'react'
import mainContext from '../../contexts/mainContext';
import AdminProfile from '../OffCanvas/Profile/AdminProfile';
import './ProfileNav.css';
import Drawer from '@mui/material/Drawer';
import avatar from '../OffCanvas/Profile/avatar.png'
import { __constants } from '../../constants';
const anchor = "right"; //DIRECTION FRO WHERE DRAWER WILL OPEN

const ProfileNav = () => {
    const context = useContext(mainContext);
    const { profileNavTitle, loginUserDetails } = context;
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <Drawer
                anchor={anchor}
                open={open}
                onClose={() => { setOpen(false) }}>
                <AdminProfile open={open} setOpen={setOpen} />
            </Drawer>
            <nav className="profile_nav">
                <h3>{profileNavTitle}</h3>
                <div className="admin_profile">
                    <div className="admin_name">
                        {loginUserDetails.firstName} {loginUserDetails.lastName}
                        <span>nona {(loginUserDetails.role).toLowerCase()}</span>
                    </div>
                    <div className="admin_profile_pic pointer" onClick={() => { setOpen(true) }}>
                        <img style={{width:40,height:40}} src={__constants.baseurl + "/" + loginUserDetails.profilePicture || avatar} alt="" />
                    </div>
                </div>
            </nav>
        </>
    )
}

export default ProfileNav
